import { render, staticRenderFns } from "./BaseSidebar.vue?vue&type=template&id=18630492&scoped=true&"
import script from "./BaseSidebar.vue?vue&type=script&lang=ts&"
export * from "./BaseSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSidebar.vue?vue&type=style&index=0&id=18630492&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18630492",
  null
  
)

export default component.exports